// navigation-tracker.service.ts

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GlobalService } from '../api/global.service';
import AlertifyHelper from './utils';
import Swal from 'sweetalert2';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class NavigationTrackerService {
  branchofficeSlug: string = '';

  constructor(
    private router: Router,
    private globalService: GlobalService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  initializeMenu(ruta: any) {
    let li_menu = ruta.snapshot.data.module;
    let data: any = localStorage.getItem('modulesSystem');
    let routes_ = JSON.parse(data);
    let notExist = false;
    let validation = false;

    for (let i in routes_) {
      let route_ = routes_[i];
      if (route_.ui_sref == '#') {
        for (let j in routes_[i].childsmodule) {
          let child_ = routes_[i].childsmodule[j];
          // console.log(child_);
          notExist = true;
          if (child_.module == li_menu) {
            // console.log("si esta ");
            notExist = false;
            validation = true;
            break;
          }
        }
      } else {
        notExist = true;
        if (route_.module == li_menu) {
          // console.log("si esta ");
          notExist = false;
          validation = true;
          break;
        }
      }

      if (validation) {
        break;
      }
    }

    if (notExist) {
      // this.alertifyMsg.warning("No tiene los permisos suficientes para acceder a la vista");
      this.router.navigate([this.branchofficeSlug + '/dashboard']);
      Swal.fire({
        icon: 'error',
        title: '! ADVERTENCIA ¡',
        text: 'No tiene los permisos suficientes para acceder a la vista'
      });
    }

    (<any>$('#sidebar-menu'))
      .find('ul')
      .children('li')
      .children('a')
      .removeClass('mm-active');

    (<any>$('#sidebar-menu'))
      .find('li.mm-active')
      .children('ul')
      .children('li')
      .removeClass('active');

    (<any>$('#sidebar-menu'))
      .find('li.mm-active')
      .children('ul')
      .children('li')
      .removeClass('mm-active');

    (<any>$('#sidebar-menu'))
      .find('li.mm-active')
      .children('ul')
      .children('li')
      .children('a')
      .removeClass('mm-active');

    if ((<any>$(window)).width() < 500) {
      if(!(<any>$('body')).hasClass('enlarged')){
        (<any>$('body')).addClass('enlarged');
      }   
    }

    setTimeout(() => {
      (<any>$('#sidebar-menu'))
        .find('ul')
        .children('#' + li_menu)
        .children('a')
        .addClass('mm-active');

      (<any>$('#module_' + li_menu)).addClass('mm-active');
      (<any>$('#module_' + li_menu)).children().addClass('mm-active');
      (<any>$('#module_' + li_menu))
        .parent('ul')
        .addClass('mm-collapse mm-show');
      (<any>$('#module_' + li_menu))
        .parent('ul')
        .parent('li')
        .children('a')
        .addClass('mm-active');
    }, 50);

    this.positionView();
  }

  positionView(){
    // console.log("focus view");
    (<HTMLInputElement>document.getElementById('content__body')).focus();

  }


  initializeMenuAdmin(tabId: string) {
    // 1. Seleccionamos el contenedor principal
    const $menu = $('#tab-menu-admin');  
    // 2. Quitamos la clase 'active' de TODOS los enlaces dentro de ese menú
    $menu.find('.nav-link').removeClass('active');
    // 3. Agregamos 'active' solo al ID que pasamos por parámetro
    // Usamos el selector de ID directamente para mayor velocidad
    $(tabId).addClass('active');
  }

}

